import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { UserEntity } from "@lifeat/shared/data-models/user/UserEntity";
import {
    getUserAccountCreationDateYYYYMMDD,
    getUserSubscriptionTier,
    isUserActiveProSubscriber,
    isUserBusinessUser,
    isUserWorkingProfessional,
} from "@lifeat/shared/user/UserUtil";
import IconButton from "@common/LifeAtButton/Variants/IconButton";
import LifeAtNotificationBadge from "@common/LifeAtNotification/LifeAtNotificationBadge/LifeAtNotificationBadge";
import { useUserContext } from "@contexts/UserContext";
import useOnUserDataLoaded from "@hooks/useOnUserDataLoaded";
import SupportChatBtnIcon from "@icons/Support-Chat-Icon.svg";
import { logClientError } from "@service/ClientLoggingService";

const BtnIcon = styled(SupportChatBtnIcon)`
    fill: ${(props) => props.theme.iconColor};
`;

function SupportChatButton() {
    const { user, userData } = useUserContext();

    const [unreadMessagesExists, setUnreadMessagesExists] = useState(false);
    const [renderChat, setRenderChat] = useState(false);

    const userCanAccessCrispChat =
        isUserActiveProSubscriber(userData?.proUserInfo) ||
        isUserBusinessUser(userData?.additionalUserSuppliedData) ||
        isUserWorkingProfessional(userData?.userType);

    useOnUserDataLoaded((loadedData: UserEntity) => {
        if (user && loadedData) {
            window.$crisp.push(["set", "user:email", [userData.email]]);
            try {
                window.$crisp.push([
                    "set",
                    "session:data",
                    [
                        [
                            ["user_uid", user.uid],
                            ["user_type", loadedData.userType],
                            ["subscription_tier", getUserSubscriptionTier(loadedData)],
                            ["account_creation_date", getUserAccountCreationDateYYYYMMDD(user.metadata.creationTime)],
                            ["is_on_desktop_app", !!window.todesktop],
                            ["lifeat_version", String(process.env.LIFEAT_VERSION)],
                        ],
                    ],
                ]);
            } catch (e) {
                console.error("Error setting Crisp session data", e);
                if (e instanceof Error) {
                    logClientError(e);
                }
            }
            setRenderChat(true);
        }
    });

    const [showChatBox, setShowChatBox] = useState(false);
    useEffect(() => {
        window.$crisp.push(["on", "chat:closed", () => setShowChatBox(false)]);
        return () => {
            window.$crisp.push(["off", "chat:closed"]);
        };
    }, []);

    useEffect(() => {
        window.$crisp.push(["on", "message:received", handleMessageReceived]);
        return () => {
            window.$crisp.push(["off", "message:received"]);
        };
    }, []);

    const handleMessageReceived = () => {
        setUnreadMessagesExists(window.$crisp.get("chat:unread:count") > 0);
    };

    // Hides the crisp chat button itself
    const setCrispChatIconDisplayNone = () => {
        const c = document.getElementById("crisp-chatbox");
        const closeChatBtn = c?.firstChild?.childNodes.item(1) as HTMLElement;
        closeChatBtn.style.cssText = "display: none!important;";
    };

    const handleClick = () => {
        window.open("https://lifeat.gitbook.io/lifeat", "_blank");
        // if (showChatBox) {
        //     window.$crisp.push(["do", "chat:hide"]);
        //     window.$crisp.push(["do", "chat:close"]);
        // } else {
        //     window.$crisp.push(["do", "chat:show"]);
        //     window.$crisp.push(["do", "chat:open"]);
        //
        //     setCrispChatIconDisplayNone();
        // }
        // setUnreadMessagesExists(window.$crisp.get("chat:unread:count") > 0);
        // setShowChatBox(!showChatBox);
    };

    return userCanAccessCrispChat && renderChat ? (
        <LifeAtNotificationBadge show={unreadMessagesExists} glow={false} top={3} right={3}>
            <IconButton variant={"normal"} size={"small"} onClick={handleClick}>
                <BtnIcon />
            </IconButton>
        </LifeAtNotificationBadge>
    ) : null;
}

export default SupportChatButton;
